import type { HttpClient } from '../http/types';
import { ENDPOINTS } from './endpoints';

export interface BackendAttachment {
  id: string;
  originalFilename: string;
  mimeType: string;
  sizeInBytes: number | null;
  createdBy: string;
  createdAt: string;
}

export interface AttachmentDownload {
  url: string;
  expiresInSeconds: number | null;
  originalFilename: string;
  mimeType: string;
  external: boolean;
}

export function createAttachmentsApi(http: HttpClient) {
  return {
    list: (projectId: string, taskId: string) =>
      http.get<BackendAttachment[]>(ENDPOINTS.attachments.root(projectId), {
        query: { taskId },
      }),
    upload: (projectId: string, taskId: string, file: File) => {
      const body = new FormData();
      body.append('file', file);
      body.append('taskId', taskId);
      return http.post<BackendAttachment>(ENDPOINTS.attachments.root(projectId), body);
    },
    download: (projectId: string, attachmentId: string) =>
      http.get<AttachmentDownload>(ENDPOINTS.attachments.download(projectId, attachmentId)),
    content: (projectId: string, attachmentId: string) =>
      http.getBlob(ENDPOINTS.attachments.file(projectId, attachmentId), { timeoutMs: 120_000 }),
    remove: (projectId: string, attachmentId: string) =>
      http.delete<void>(ENDPOINTS.attachments.byId(projectId, attachmentId)),
  };
}
